export default "__VITE_ASSET__Bul1Ebw9__"